import React from 'react';
import {
  OPTION_LABELS,
  PERMISSION_CONFIG,
  PERMISSION_KEYS,
  UserPermissionKey,
  PermissionKey,
  PermissionValue,
  User_PermissionKey,
  USER_PERMISSION_CONFIG
} from './rolePermissionConfig';
import { useAppSelector } from 'src/redux/storeHooks';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

interface PermissionCardsProps {
  permissions: Record<PermissionKey, PermissionValue>;
  onChange: (section: PermissionKey, value: PermissionValue) => void;
  isLoginAdminAcess: boolean;
  userPermissionList?: any[];
}

const PermissionCards: React.FC<PermissionCardsProps> = ({
  permissions,
  onChange,
  isLoginAdminAcess,
  userPermissionList
}) => {
  const activeKeys = isLoginAdminAcess ? PERMISSION_KEYS : User_PermissionKey;
  const activeConfig = isLoginAdminAcess ? PERMISSION_CONFIG : USER_PERMISSION_CONFIG;

  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData);
  const isSuperuser = fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.account_type === 'ADMIN_STAFF';
  const defaultPermissionsForNonSuperuser: Record<PermissionKey, PermissionValue> = React.useMemo(() => {
    if (isSuperuser || !userPermissionList?.length) return permissions;

    const defaults: Record<PermissionKey, PermissionValue> = { ...permissions };
    userPermissionList.forEach((item) => {
      const key = item.key as PermissionKey;
      if (!defaults[key]) {
        defaults[key] = 'RESTRICT';
      }
    });
    return defaults;
  }, [isSuperuser, userPermissionList, permissions]);
  console.log(userPermissionList, "userPermissionList")


  return (
    <div className="role-modal__permissions">
      {/* ================= SUPERUSER FLOW (UNCHANGED) ================= */}
      {isSuperuser &&
        activeKeys.map((key) => {
          const config = activeConfig[key as PermissionKey | UserPermissionKey];
          if (!config) return null;

          return (
            <div className="permission-card" key={key}>
              <div className="permission-card__illustration">
                <img src={config.illustration} alt={`${config.title} illustration`} />
              </div>
              <div className="permission-card__body">
                <div className="permission-card__heading">
                  <h6>{config.title}</h6>
                </div>
                <div className="permission-card__options">
                  {config.options.map((option) => {
                    const isActive = permissions[key] === option;

                    return (
                      <label
                        key={option}
                        className={[
                          'permission-option',
                          `permission-option--${option.toLowerCase()}`,
                          isActive ? 'is-active' : ''
                        ].join(' ')}
                      >
                        <input
                          type="radio"
                          name={`${key}-permission`}
                          value={option}
                          checked={isActive}
                          onChange={() => onChange(key, option)}
                        />
                        <span className="permission-option__indicator" />
                        <span className="permission-option__label">
                          {OPTION_LABELS[option]}
                        </span>
                      </label>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}

      {/* ================= NON-SUPERUSER FLOW ================= */}
      {!isSuperuser && (
        <>
          {!userPermissionList || userPermissionList.length === 0 ? (
            <div className="text-center py-2 text-muted">
              <h6>No Roles Found</h6>
            </div>
          ) : (
            userPermissionList?.map((item) => {
              const key = item.key as PermissionKey;

              return (
                <div className="permission-card" key={item.key}>
                  <div className="permission-card__body">
                    <div className="permission-card__heading">
                      <h6 style={{ display: 'inline-flex', gap: '5px', marginBottom: 0 }}>
                        {item.display_name}

                        {item?.tooltip && (
                          <OverlayTrigger
                            placement="top"
                            popperConfig={{
                              modifiers: [
                                {
                                  name: 'flip',
                                  enabled: false
                                }
                              ]
                            }}
                            overlay={<Tooltip>{item.tooltip}</Tooltip>}
                          >
                            <span style={{ cursor: 'pointer', color: 'darkgrey' }}>
                              <FontAwesomeIcon icon={faInfoCircle} />
                            </span>
                          </OverlayTrigger>

                        )}
                      </h6>
                    </div>

                    <div className="permission-card__options">
                      {item.permissions.map((perm: any) => {
                        const isActive = defaultPermissionsForNonSuperuser[key] === perm.value;

                        return (
                          <label
                            key={perm.value}
                            className={['permission-option', `permission-option--${perm.value.toLowerCase()}`,
                              isActive ? 'is-active' : ''
                            ].join(' ')}
                          >
                            <input
                              type="radio"
                              name={`${key}-permission`}
                              value={perm.value}
                              checked={isActive}
                              onChange={() => onChange(key, perm.value)}
                            />
                            <span className="permission-option__indicator" />
                            <span className="permission-option__label">
                              {perm.label}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </>
      )}
    </div>
  );
};

export default PermissionCards;
